import React, { useState, useEffect } from 'react';
import '../scss/ThemeToggle.scss';

const ThemeToggle = () => {
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) return savedTheme;
    
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  });

  useEffect(() => {
    const root = document.documentElement;

    // Swap the theme instantly. A site-wide color crossfade is cheap on
    // desktop but janky on mobile: the nav's backdrop-filter blur must
    // re-rasterize every frame as colors animate behind it. Suppressing
    // transitions for the swap turns ~15 blurred repaints into one.
    const noTransition = document.createElement('style');
    noTransition.appendChild(
      document.createTextNode('*,*::before,*::after{transition:none!important}')
    );
    document.head.appendChild(noTransition);

    root.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);

    // Force a reflow so the new theme paints with transitions off, then
    // restore them next frame for hover/focus animations.
    void document.body.offsetHeight;
    const raf = window.requestAnimationFrame(() => noTransition.remove());

    return () => {
      window.cancelAnimationFrame(raf);
      noTransition.remove();
    };
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => prev === 'light' ? 'dark' : 'light');
  };

  return (
    <button 
      className="theme-toggle" 
      onClick={toggleTheme}
      aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
    >
      <div className="theme-toggle-switch">
        <div className="theme-toggle-track">
          <div className="theme-toggle-thumb">
            {theme === 'light' ? (
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="5" />
                <line x1="12" y1="1" x2="12" y2="3" />
                <line x1="12" y1="21" x2="12" y2="23" />
                <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
                <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
                <line x1="1" y1="12" x2="3" y2="12" />
                <line x1="21" y1="12" x2="23" y2="12" />
                <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
                <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
              </svg>
            ) : (
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
              </svg>
            )}
          </div>
        </div>
      </div>
      
      <div className="theme-toggle-icon">
        {theme === 'light' ? (
          <i className="fas fa-sun"></i>
        ) : (
          <i className="fas fa-moon"></i>
        )}
      </div>
    </button>
  );
};

export default ThemeToggle;